import React, { useState, useEffect } from 'react'
import { AlertProvider } from './global-fms/context/AlertContext';
import { useAuth } from './global-fms/context/AuthContext'
import { Route, Routes } from 'react-router'

import AdminRoutes from './global-fms/routes/AdminRoutes'
import AuthRoutes from './global-fms/routes/AuthRoutes'

import LogoutPage from './global-fms/app/auth/pages/LogoutPage';
import RechargePage from './global-fms/app/admin/business/pages/RechargePage';
import SuspendPage from './global-fms/app/admin/business/pages/SuspendPage';
import ManagerRoutes from './global-fms/routes/ManagerRoutes';
import Error404Page from './global-fms/app/errorPages/Error404Page';
import Error401Page from './global-fms/app/errorPages/Error401Page';
import ChangePasswordPage from './global-fms/app/auth/pages/ChangePasswordPage';
import { AppDataProvider } from './global-fms/context/AppDataContext';
import { AppESSDataProvider } from './global-fms/context/AppESSDataContext';
import EssRoutes from './global-fms/routes/EssRoutes';
import 'leaflet/dist/leaflet.css';

function App() {
    const {isLoggedIn,authUser} = useAuth();
    //console.log("authUSerrole", authUser)
    sessionStorage.removeItem("businessInfo");

    // Disable Right Click Start
    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])
    // Disable Right Click End
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                    
                    { authUser.role <= 2 &&
                        <AppDataProvider>
                            <AdminRoutes/>
                        </AppDataProvider>
                    }

                    { authUser.role == 4 &&
                        <AppESSDataProvider>
                            <EssRoutes/>
                        </AppESSDataProvider>
                    }
                    
                    <Routes>
                        {/*Logout */}
                        <Route path="/admin/recharge-page" element={<RechargePage />}></Route>
                        <Route path="/admin/suspend-page" element={<SuspendPage />}></Route>
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                        <Route path="/auth/change-password" element={<ChangePasswordPage />}></Route>
                        <Route path="/404" element={<Error404Page/>}></Route>
                        <Route path="/401" element={<Error401Page/>}></Route>
                    </Routes>
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App